import React, { PropsWithChildren } from 'react'
import { Page } from '@/payload-types'
import { HeroBlock, Blocks } from '@/components'

interface ServiceMainProps extends PropsWithChildren {
  page: Page
}

function ServiceMain({ page, children }: Readonly<ServiceMainProps>) {
  return (
    <main className="flex-1 flex flex-col mt-12">
      <HeroBlock title={page.title} lead={page.lead} blockType="hero" />
      {children}
      {page.blocks && <Blocks blocks={page.blocks} />}
    </main>
  )
}

export { ServiceMain }
